module.exports = __webpack_public_path__ + "images/frontpage_infinite@2x.png?4fbf706e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/frontpage_infinite@2x.png
// module id = 652
// module chunks = 7